import { useEffect, useState, useMemo } from 'react';
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef } from '@mui/x-data-grid-pro';
import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import { useSelector } from 'react-redux';
import CardDetail from './CardDetail';
import { RootState } from '../../../../store/store';
import CustomBtn from '../../../../components/customBtn/CustomBtn';
import { useFetchDataQuery } from '../../services/services';
import { ConfirmationModal } from '../../../../components/ConfirmationModal';
import Table from '../../../../components/table/Table';
import { filterOperatorsDateTime } from '../../../../utils/filter-date-time';
import { usePermission } from '../../../../hooks/usePermission';
import { Alert, Box, Card, Container, Typography } from '@mui/material';
import {
  Security as SecurityIcon,
} from '@mui/icons-material';

const CardList = () => {
  // Permission kontrolları
  const { hasPermission: canViewCardDetail } = usePermission({
    code: 'Corporate.GET.Reading.KartDetayıGörüntüleme'
  });
  const { hasPermission: canViewCardLimit } = usePermission({
    code: 'Corporate.GET.Reading.KartLimitGörüntüleme'
  });
  const { hasPermission: canUpdateCardLimit } = usePermission({
    code: 'Corporate.POST.Updating.KartLimitGüncelleme'
  });

  const canShowCardDetailModal: boolean = Boolean(canViewCardDetail || canViewCardLimit || canUpdateCardLimit);

  // Permission kontrolları
  const { hasPermission: canViewCardList, isLoading: isPermissionLoading } = usePermission({
    code: 'Corporate.POST.Reading.KartListeleme'
  });

  // Lookup fonksiyonları
  const customCardTypeCellTemplate = (params: any) => {
    const data = params.value || params.row?.cardType;
    if (data === 'V') {
      return 'Sanal';
    }
    if (data === 'P') {
      return 'Fiziksel';
    }
    return data || '';
  };

  const customCardBrandCellTemplate = (params: any) => {
    const data = params.value || params.row?.cardBrand;
    if (data === 'T') {
      return 'Troy';
    }
    return data || '';
  };

  const customIsVirtualCellTemplate = (params: any) => {
    const data = params.value !== undefined ? params.value : params.row?.isVirtual;
    if (data === true){
      return "Evet";
    }
    if (data === false) {
      return "Hayır";
    }
    return '';
  };

  const customStatusCellTemplate = (params: any) => {
    const data = params.value || params.row?.status;
    if (data === 'A') {
      return 'Açık Kart';
    }
    if (data === 'T') {
      return 'Geçici Kapalı';
    }
    if (data === 'I') {
      return 'İptal Kart';
    }
    if (data === 'R') {
      return 'Risk';
    }
    if (data === 'S') {
      return 'Stoplist';
    }
    if (data === 'K') {
      return 'Bloke Kart';
    }
    if (data === 'B') {
      return 'Bekleyen Kart';
    }
    if (data === 'V') {
      return 'Süresi Dolmuş';
    }
    if (data === 'F') {
      return 'Fraud';
    }
    return data || '';
  };
  const { isAuthenticated } = useSelector((state: RootState) => state.login);
  const { currentUserState } = useSelector((state: RootState) => state.currentUserState);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState<Record<string, boolean>>({
    isVirtual: false,
    createDate: false,
    updateDate: false,
  });
  const [rowDetail, setRowDetail] = useState<any>({});
  const [companyIsCardLimitUsed, setCompanyIsCardLimitUsed] = useState<boolean>(true);

  const customBtnClick = (params: any) => {
    setRowDetail({
      ...params.row,
      isPersonalized: !!params.row.embossName 
    });
  };
  const checkCurrentUser = async () => {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser && JSON.parse(currentUser)) {
      //  currentUser?.find(user => user.selectedUserInfo === 1)?.companyId;
      const parsedUser = JSON.parse(currentUser);
      return parsedUser;
    }
  }


  useEffect(() => {
    const fetchUsers = async () => {
      const response = await checkCurrentUser();
      ;
      if (response?.length > 0) {
        const selectedUser = response?.find((user: any) => user.selectedUserInfo === 1);
        if (selectedUser.companyIsCardLimitUsed === false || selectedUser.companyIsCardLimitUsed === 0) {
          setCompanyIsCardLimitUsed(false)
        }
      }
    };
    if (isAuthenticated)
      fetchUsers();
  }, [isAuthenticated]);

  const getColumns = useMemo((): GridColDef[] => [
    { field: 'cardWalletNo', headerName: 'Hesap Numarası', width: 250 },
    { field: 'cardNo', headerName: 'Kart Numarası', width: 222, },
    {
      field: 'embossName', headerName: 'Kart Üzerindeki İsim', width: 200
    },
    { field: 'cvv', headerName: 'Cvv', width: 150, filterable: false, sortable: false },
    // @ts-ignore
    { field: 'expiryDate', headerName: 'Son Kullanma Tarihi', width: 200, type: "datetime", filterOperators: filterOperatorsDateTime, filterable: false, sortable: false },
    { field: 'cardIBAN', headerName: 'IBAN', width: 200 },
    {
      field: 'cardBrand',
      headerName: 'Kart Markası',
      width: 180,
      type: 'singleSelect',
      valueOptions: [
        { value: 'T', label: 'Troy' }
      ],
      renderCell: (params: any) => customCardBrandCellTemplate(params)
    },
    { 
      field: 'isVirtual', 
      headerName: 'Sanal Mı', 
      width: 200,
      type: 'singleSelect',
      valueOptions: [
        { value: 'true', label: 'Evet' },
        { value: 'false', label: 'Hayır' },
        
      ],
      renderCell: (params: any) => customIsVirtualCellTemplate(params)
    },
    { field: 'customerName', headerName: 'Müşteri Adı', width: 200 },
    {
      field: 'cardType',
      headerName: 'Kart Tipi',
      width: 130,
      type: 'singleSelect',
      valueOptions: [
        { value: 'V', label: 'Sanal' },
        { value: 'P', label: 'Fiziksel' }
      ],
      renderCell: (params: any) => customCardTypeCellTemplate(params)
    },
    {
      field: 'status',
      headerName: 'Durumu',
      width: 200,
      type: 'singleSelect',
      valueOptions: [
        { value: 'A', label: 'Açık Kart' },
        { value: 'T', label: 'Geçici Kapalı' },
        { value: 'I', label: 'İptal Kart' },
        { value: 'R', label: 'Risk' },
        { value: 'S', label: 'Stoplist' },
        { value: 'K', label: 'Bloke Kart' },
        { value: 'B', label: 'Bekleyen Kart' },
        { value: 'V', label: 'Süresi Dolmuş' },
        { value: 'F', label: 'Fraud' }
      ],
      renderCell: (params: any) => customStatusCellTemplate(params)
    },
    {
      field: 'createDate',
      headerName: 'Oluşturulma Tarihi',
      width: 200,
      type: "dateTime",
      valueGetter: (params: any) => {
        return params.value ? new Date(params.value) : null;
      },
      filterOperators: filterOperatorsDateTime
    },
    {
      field: 'updateDate',
      headerName: 'Güncellenme Tarihi',
      width: 200,
    },
    // Detay butonunu sadece yetkisi varsa göster (3 permission OR)
    ...(companyIsCardLimitUsed && canShowCardDetailModal ? [{
      field: "detail",
      headerName: 'Detay',
      width: 100,
      renderCell: (params: any) => {
      const isDisabled = params.row.customerId === 0 || params.row.customerId === null || params.row.customerId === "";
      return <CustomBtn disabled={isDisabled} name="Detay" onclick={() => customBtnClick(params)} />;
      },
      filterable: false, sortable: false
    }] : []),
  ], [companyIsCardLimitUsed, canShowCardDetailModal]);

  const [requestBody, setRequestBody] = useState({
    filters: [],
    pageSize: 25,
    page: 1,
    orderBy: "",
    orderDesc: false,
    customerId: currentUserState?.companyId || undefined,
  });
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const [columns, setColumns] = useState<GridColDef[]>(getColumns);
  const listUrl = `/Card/CustomerCardsV2?customerId=${currentUserState?.companyId}`;

  // Kurum değişince requestBody.customerId güncellenmezse liste refetch olmayabilir
  useEffect(() => {
    if (!currentUserState?.companyId) return;
    setPaginationModel({ page: 0, pageSize: 25 });
    setRequestBody((prev) => ({
      ...prev,
      filters: [],
      pageSize: 25,
      page: 1,
      orderBy: "",
      orderDesc: false,
      customerId: currentUserState.companyId,
    }));
  }, [currentUserState?.companyId]);

  // Permission kontrolünü hook ile yap

  const shouldFetchCardList = Boolean(requestBody?.customerId) && !isPermissionLoading && canViewCardList;
  const { data: fetchData, isFetching, error: fetchError, isLoading: isFetchLoading } = useFetchDataQuery(
    { url: listUrl, filter: requestBody, method: "POST" },
    { skip: !shouldFetchCardList }
  );

  // Columns'ları canViewCardDetail değiştiğinde güncelle
  useEffect(() => {
    setColumns(getColumns);
  }, [getColumns]);


  const debounce = (func: any, delay: any) => {
    let timeoutId: any;
    return (...args: any) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const onFilterChange = debounce((filterObj: any) => {
    setRequestBody((prev) => ({ ...prev, filters: filterObj }));
  }, 500);

  const handleChangePagination = (model: any) => {
    setPaginationModel(model);
    setRequestBody((prev) => ({ ...prev, pageSize: model.pageSize, page: model.page + 1 }));
  };

  const sortModelChange = (model: any) => {
    setRequestBody((prev) => ({ ...prev, orderBy: model[0]?.field ?? "", orderDesc: model[0]?.sort === "asc" }));
  }

  const handleClose = () => {
    setRowDetail({});
  };


  // Eğer permission yüklendi ve kart listesi görüntüleme yetkisi yoksa uyarı göster (yüklenirken tablo + skeleton gösterilir)
  if (!isPermissionLoading && !canViewCardList) {
    return (
      <Box sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Card sx={{
          maxWidth: 500,
          p: 4,
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(239, 68, 68, 0.1)',
          background: 'rgba(255,255,255,0.9)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(252, 165, 165, 0.3)',
          textAlign: 'center'
        }}>
          <SecurityIcon sx={{ fontSize: 64, color: '#ef4444', mb: 3 }} />
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#dc2626', mb: 2 }}>
            Erişim Engellendi
          </Typography>
          <Typography variant="body1" sx={{ color: '#7f1d1d', lineHeight: 1.6 }}>
            Bu sayfaya erişim yetkiniz bulunmamaktadır. Sistem yöneticinizle iletişime geçiniz.
          </Typography>
        </Card>
      </Box>
    );
  }


  return <>
    <ConfirmationModal
      isOpen={Object.keys(rowDetail).length > 0}
      onClose={handleClose}
      title="Kart Detayları"
      isLoading={false}
      confirmButtonText={''}
      closeButtonText="Kapat"
      optionalWidth="1000px"
      children={<CardDetail cardDetail={rowDetail} handleClose={handleClose} />}
    />
    <Table
      sortModelChange={sortModelChange}
      isLoading={isPermissionLoading || isFetching || (fetchData === undefined && !!requestBody?.customerId)}
      initialState={{
        pinnedColumns: {
          left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, 'actions'],
          right: canShowCardDetailModal ? ['detail'] : [],
        },
      } as GridInitialStatePro}
      sx={{
        margin: fetchData?.data?.length > 0 && paginationModel.pageSize > 25 ? "0px 0 25px 0 !important" : "0px !important",
        '& .MuiDataGrid-root': {
          borderRadius: 2,
          border: 'none',
        },
        '& .MuiDataGrid-main': {
          borderRadius: 2,
        },
        '& .MuiDataGrid-columnHeaders': {
          background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.9) 0%, rgba(241, 245, 249, 0.95) 100%)',
          borderBottom: '2px solid rgba(226, 232, 240, 0.8)',
          borderRadius: '8px 8px 0 0',
        },
        '& .MuiDataGrid-cell': {
          borderBottom: '1px solid rgba(226, 232, 240, 0.5)',
        },
        '& .MuiDataGrid-row': {
          '&:hover': {
            background: 'rgba(59, 130, 246, 0.04)',
          },
          '&.Mui-selected': {
            background: 'rgba(30, 60, 114, 0.08)',
            '&:hover': {
              background: 'rgba(30, 60, 114, 0.12)',
            },
          },
        },
      }}
      columnVisibilityModel={columnVisibilityModel}
      setColumnVisibilityModel={setColumnVisibilityModel}
      checkboxSelection
      isMasterDetailActive={false}
      headerFilters={true}
      columnVisibilityConfigKey="CardListPageFilterColumnVisibilityKey"
      filterKey="CardListPageFilter"
      rows={fetchData?.data ?? []}
      columns={columns}
      handleFilterChange={onFilterChange}
      paginationModel={paginationModel}
      onPaginationModelChange={handleChangePagination}
      rowCount={fetchData?.totalCount ?? 0}
      getRowId={(row: any) => row.id}
      idName={"id"}
      listUrl={listUrl}
      fetchData={fetchData}
      showDownloadButton={true}
      listName="Kart Listesi"
      requestBody={requestBody}
      fetchMethod="POST"
    />
  </>
};

export default CardList;

